import type { SVSType } from './svs-types'
import type { ComponentType } from 'react'

/**
 * Registry mapping SVS type strings to their React renderer components.
 * Adding a new visualization type is: (1) create a renderer, (2) register it here.
 */

// Renderers accept typed payloads but the registry stores them generically
type RendererComponent = ComponentType<{ payload: any }>

const registry = new Map<SVSType, RendererComponent>()

export function registerRenderer(type: SVSType, component: RendererComponent) {
  registry.set(type, component)
}

export function getRenderer(type: SVSType): RendererComponent | undefined {
  return registry.get(type)
}

export function hasRenderer(type: SVSType): boolean {
  return registry.has(type)
}

export function getRegisteredTypes(): SVSType[] {
  return Array.from(registry.keys())
}
